export default "__VITE_ASSET__CxKnU_l6__"